/**
 * Proforma Invoice service.
 * Integrated with backend API.
 */

import { apiClient } from './apiClient';

const API_BASE_URL = '/api/v1';

/**
 * Generate a proforma invoice.
 * @param {Object} payload - { branch_id, client_id, buyer_order_no, items: [{ productUid, cartons, orderQty }] }
 * @returns the rendered invoice snapshot (exporter, buyer, items, totals, invoiceNumber, documentVersion).
 */
export const generateProformaInvoice = async (payload) => {
  try {
    const response = await apiClient.post(`${API_BASE_URL}/proforma-invoices/generate`, payload);
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Failed to generate proforma invoice:', error);
    throw error;
  }
};

/**
 * List recent proforma invoices.
 */
export const getProformaInvoices = async () => {
  try {
    const response = await apiClient.get(`${API_BASE_URL}/proforma-invoices`);
    return response.data?.data ?? [];
  } catch (error) {
    console.error('Failed to fetch proforma invoices:', error);
    return [];
  }
};

/**
 * Fetch a stored invoice snapshot (re-print).
 */
export const getProformaInvoice = async (id) => {
  try {
    const response = await apiClient.get(`${API_BASE_URL}/proforma-invoices/${id}`);
    return response.data?.data ?? null;
  } catch (error) {
    console.error('Failed to fetch proforma invoice:', error);
    throw error;
  }
};
